import * as React from "react";
import AdmissionCreateForm from "../components/AdmissionCreateForm";


export default function AdmissionsCreatePage() {
  return (
    <>
      <AdmissionCreateForm/>
    </>
  );
}